import * as React from 'react';
import {Auth, CharacteristicDataService} from '../../services';
import { Characteristic } from '../../models';
import { PVAPage } from '../../components';
import { BaseRouteProps, EditState, EditProps } from '../../interfaces';
import { CharacteristicForm } from './CharacteristicForm';
import { UserStore, FilterStore } from '../../stores';
import { inject, observer } from 'mobx-react';
import { computed } from 'mobx';
import { NavLink } from 'react-router-dom';
import {Roles} from "../../stores/Constants";

interface CharacteristicEditProps extends BaseRouteProps<EditProps> {
    UserStore?: UserStore;
    FilterStore?: FilterStore;
    Auth?: Auth;
}

interface CharacteristicEditState extends EditState<Characteristic> {
    open: boolean;
}

@inject('UserStore', 'FilterStore', 'Auth') @observer
export class CharacteristicView extends React.Component<CharacteristicEditProps, CharacteristicEditState> {
    private characteristicDataService = new CharacteristicDataService(this.props.notificationService);

    constructor(props: CharacteristicEditProps) {
        super(props);

        this.state = {
            originalEntity: undefined,
            open: false
        };
    }

    public componentDidMount() {
        if (this.props.match.params.id) {
            this.characteristicDataService.get(this.props.match.params.id)
                .then((characteristic: Characteristic) => {
                    this.setState({
                        originalEntity: characteristic
                    });
                });
        }
    }

    @computed get isSuperAdmin() {
        return this.props.Auth!.userHasRole(Roles.SuperAdmin);
    }

    private delete() {
        if (this.state.originalEntity && confirm('Are you sure you want to delete this characteristic?')) {
            this.characteristicDataService.delete(this.state.originalEntity).then(() => {
                if (this.state.originalEntity) {
                    this.props.history.push('/surveyversion/' + this.state.originalEntity.surveyVersionID + '/characteristics');
                }
            });
        }
    }

    private ActionsButton() {
        return (
            <div className="btn-group dropdown">
                <button type="button" className="btn btn-primary"  onClick={(e) => this.setState({open: !this.state.open })}>
                    <span>Actions </span>
                    <span className="caret" />
                </button>
                <ul className={`action-menu dropdown-menu ${this.state.open ? 'open' : ''}`}>
                    {this.isSuperAdmin && <li className="options-header">Survey Maintenance</li>}
                    {this.isSuperAdmin && <li className="options-entry" onClick={(e) => this.delete()}>
                        <div className="options-entry-title">
                            <span className="glyphicon glyphicon-delete" /> <span style={{color: 'red'}}> Delete Characteristic</span>
                        </div>
                        <div className="options-entry-desc">
                            This will soft delete the characteristic from the system.
                        </div>
                    </li>}

                </ul>
        </div>);
    }

    public render() {
        if (this.state.originalEntity === undefined) {
            return <div />;
        }

        return (
            <PVAPage>
                <PVAPage.Header>
                    <PVAPage.Header.Buttons>
                        <NavLink to={'/surveyversion/' + this.state.originalEntity.surveyVersionID + '/characteristics'}>
                            <span className="glyphicon glyphicon-arrow-left" />
                        </NavLink>
                        {this.isSuperAdmin && this.ActionsButton()}
                    </PVAPage.Header.Buttons>
                    <div className="title">
                        Characteristic Edit
                        <span className="light"> &nbsp; Defines what Raw Scores are used to calculate a Users Score.</span>
                    </div>
                </PVAPage.Header>

                <PVAPage.Body>
                    <CharacteristicForm defaultValues={this.state.originalEntity} surveyVersionId={this.state.originalEntity.surveyVersionID} notificationService={this.props.notificationService} submit={(e: any) => this.save(e)} />
                </PVAPage.Body>

                <PVAPage.Footer />
            </PVAPage>);
    }

    private save(values: any) {
        this.characteristicDataService.update(values);
    }
}



// WEBPACK FOOTER //
// ./src/components/characteristic/CharacteristicEdit.tsx